export const filterStatusOptions = [
  { label: "Todas", value: "" },
  { label: "Aguardando análise", value: "1" },
  { label: "Em análise", value: "2" }
];
